export default __webpack_public_path__ + "static/loja-4-5616c05a22156b5c5524c2a67e1948c7.png";